






























import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import ChecklistPicker from '@/components/ChecklistPicker.vue'
import { DataStore, Storage } from 'aws-amplify'
import { Media, Checklist, ChecklistMedia } from '../models/index' // Districts
import { copyFromDataStore, HubEvents, imgProxyBase } from '@/amplify'
import { mutateSnackbar } from '@/store/snackbar'
import ConfirmDialog from '@/components/dialogs/Confirm.vue'
import { query as tenant } from '@/store/tenant'

@Component<MediaEditView>({
  components: {
    ChecklistPicker,
    ConfirmDialog,
  },
  apollo: {
    tenant,
  },
  // @ts-ignore
  metaInfo() {
    return {
      title: this.$t('media.title')
    }
  },
})
export default class MediaEditView extends Vue {

  isLoading = false  
  item = null

  get imageSrc() {
    if(!this.item) return '';
    // @ts-ignore
    return `${imgProxyBase}?key=public/${this.item.s3key}&w=400&h=400&ext=jpg`;
  }

  get mediaId() {
    return this.$route.params.mediaId
  }

  @Watch('mediaId', { immediate: true })
  refetchItem() {
    this.getMediaItem()
  }

  async getMediaItem() {
    this.isLoading = true
    try {
      const query = await DataStore.query(Media, this.mediaId)
      if (!query) throw new Error('Media not found')
      this.item = { ...copyFromDataStore(query), 
        // @ts-ignore
        checklistIds: [...new Set((await query.checklists.toArray()).map((e) => e.checklistID))],
      }
    } catch (err) {
      mutateSnackbar({ text: err, color: `error` }, this.$apollo)
    }
    this.isLoading = false
  }

  async deleteItem() {
    try {
      // @ts-ignore
      await Storage.remove(this.item.s3key);
      await DataStore.delete(Media, this.mediaId);
      mutateSnackbar(
        { text: String(`Erfolgreich gelöscht`), color: `success` },
        this.$apollo
      )
      this.$router.push({ name: 'medias' })
    } catch (err) {
      mutateSnackbar({ text: err, color: `error` }, this.$apollo)
    }
  }

  async saveItem() {
    this.isLoading = true
    try {
      // @ts-ignore
      var relations = []
      const media = await DataStore.query(Media, this.mediaId);
      // @ts-ignore
      const mediaChecklists = await media.checklists.toArray()
      // @ts-ignore
      const relationsToDelete = mediaChecklists.filter(e => !this.item.checklistIds.includes(e.checklistID))
      await Promise.all(relationsToDelete.map(async (checklistMedia) => {
        await DataStore.delete(ChecklistMedia, checklistMedia.id)
      }));
      // @ts-ignore
      const relationsToCreate = this.item.checklistIds.filter(e => 
        // @ts-ignore
        !mediaChecklists.find(existing => existing.checklistID == e)
      )
      await DataStore.save(
        Media.copyOf(
          // @ts-ignore
          media,
          // @ts-ignore
          updated => {
            // @ts-ignore
            for (const [key, value] of Object.entries(this.item)) {
              if(key !== "checklistIds") {
                // @ts-ignore
                updated[key] = value
              }
            }
          }
        )
      )
      // @ts-ignore
      await Promise.all(relationsToCreate.map(async (checklistId) => {
        await DataStore.save(
          // @ts-ignore
          new ChecklistMedia({
            // @ts-ignore
            checklist: await DataStore.query(Checklist, checklistId),
            // @ts-ignore
            media,
            // @ts-ignore
            tenant: this.tenant.id,
          })
        );
      }))
      mutateSnackbar(
        { text: String(`Erfolgreich gespeichert`), color: `success` },
        this.$apollo
      )
    } catch (err) {
      mutateSnackbar({ text: err, color: `error` }, this.$apollo)
    }
    this.isLoading = false
  }

}
